import request from '@/utils/request'
//全部作业评论
export function replyList(data) {
    return request({
        url: '/api/reply/ReplyList',
        method: 'POST',
        data: data || {}
    })
}
//提交作业评论
export function ReplySub(data) {
    return request({
        url: '/api/reply/ReplySub',
        method: 'POST',
        data: data || {}
    })
}